function initTabbedContent(tabID) {

    var tabSet = document.querySelector('.tabSet_' + tabID),
        tab = tabSet.querySelectorAll('.tabs__tab'),
        tabPanel = tabSet.querySelectorAll('.tabs__content');

    tab.forEach(function (el) {
        el.addEventListener('click', function() {
            var id = this.getAttribute('data-tab');
            var tabContent = tabSet.querySelector('.'+id);

            // add and remove active classes
            tab.forEach(function(e) {
                e.classList.remove('tabs__tab--active')
                e.setAttribute('aria-selected', 'false')
            })
            
            el.classList.add('tabs__tab--active')
            el.setAttribute('aria-selected', 'true')
            
            // show relevant tab content
            tabPanel.forEach(function(e) {
                e.classList.add('hidden')
                e.setAttribute('aria-hidden', 'true')
            })
            tabContent.classList.remove('hidden')
            tabContent.setAttribute('aria-hidden', 'false')
        })
    })
}

// function initTabbedContent(tabID) {

//     var $tabSet = $('.tabSet_' + tabID);
//     var $tabs__tab = $tabSet.find('.tabs__tab');
//     var $tab__content = $tabSet.find('.tabs__content');

//     $tabs__tab.click(function () {

//         var id = $(this).data('tab');
//         var $thisContentTab = $tabSet.find('.'+id);

//         $tabs__tab.removeClass('tabs__tab--active');
//         $(this).addClass('tabs__tab--active');

//         $tab__content.addClass('hidden');
//         $thisContentTab.removeClass('hidden');

//         // Update aria tags
//         $tabs__tab.attr('aria-selected', 'false');
//         $(this).attr('aria-selected', 'true');

//         $tab__content.attr('aria-hidden', 'true');
//         $thisContentTab.attr('aria-hidden', 'false');

//     });
// }